import React, { useState, useContext, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { routeConstant } from "../../routing/utils/routeConstant";
import "./header.css";
import "../../screens/Dashboard/index.css";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import {
  LOCAL_STORAGE_KEY,
  LOCAL_STORAGE_USER_KEY,
  basename,
} from "../../Config";
import { UserService } from "../../services/user-service";
import { AuthContext } from "../../store/context/AuthProvider";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import urlResolver from "../../utils/urlResolver";
import { withTranslation } from "react-i18next";
import instance from "../../api/interceptor";
import { API_PATH } from "../../constant/apiPath";
import Dialog from "@mui/material/Dialog";
import { Checkbox, DialogActions } from "@mui/material";
import { setSelectedOrgCode, triggerRefresh } from "../../store/redux/orgSlice";
const drawerWidth = 240;

function Header(props) {
  const [companyDetails, setCompanyDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [tempSelectedOrgCodes, setTempSelectedOrgCodes] = useState([]);
  // const [selectedOrgCode, setSelectedOrgCode] = useState(
  //   localStorage.getItem("SELECTED_ORG_CODE") || ""
  // );
  const { selectedOrgCodes } = useSelector((state) => state.org);
  const dispatch = useDispatch();
  const handleClickOpen = () => {
    try {
      const stored = localStorage.getItem("SELECTED_ORG_CODE");
      const parsedStored = stored ? JSON.parse(stored) : [];
      const initial =
        Array.isArray(selectedOrgCodes) && selectedOrgCodes.length
          ? selectedOrgCodes
          : parsedStored || [];
      setTempSelectedOrgCodes(initial);
    } catch (err) {
      setTempSelectedOrgCodes(
        Array.isArray(selectedOrgCodes) ? selectedOrgCodes : [],
      );
    }
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    try {
      if (event && typeof event.stopPropagation === "function")
        event.stopPropagation();
    } catch (e) {}
    setOpen(false);
  };

  const handleSave = (e) => {
    try {
      if (e && typeof e.stopPropagation === "function") e.stopPropagation();
    } catch (err) {}
    if (tempSelectedOrgCodes && tempSelectedOrgCodes.length) {
      localStorage.setItem(
        "SELECTED_ORG_CODE",
        JSON.stringify(tempSelectedOrgCodes),
      );
    } else {
      localStorage.removeItem("SELECTED_ORG_CODE");
    }
    setOpen(false);
    try {
      dispatch(setSelectedOrgCode(tempSelectedOrgCodes));
      dispatch(triggerRefresh());
    } catch (err) {}
  };

  const getCompanyCode = async (pageNumber) => {
    if (loading) return;

    setLoading(true);
    try {
      const res = await instance.get(
        `${API_PATH.ORGCODE}?pageNumber=${pageNumber}&pageSize=10`,
      );

      if (res?._IsSuccess) {
        const newData = res?._Data ?? [];

        setCompanyDetails((prev) => [...prev, ...newData]);
        setTotalItems(res?._TotalItem ?? 0);
      }
    } catch (err) {
      console.log("get company error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCompanyCode(1);
  }, []);

  let navItems = [
    { key: "IsPorcess", value: "Process", name: "process" },
    { key: "IsOrder", value: "Orders", name: "orders" },
    { key: "IsFinance", value: "Financial", name: "financial" },
    { key: "IsReport", value: "Report", name: "report" },
    { key: "IsMyTeam", value: "My team", name: "my team" },
  ];
  const { t } = props;
  const { i18n } = useTranslation();

  function changeLanguage(e) {
    i18n.changeLanguage(e.target.value);
  }

  const [logout, setLogout] = useState(true);
  const Navigate = useNavigate();
  const Auth = useContext(AuthContext);
  const context = useContext(AuthContext);
  const location = useLocation();
  const { permissions } = useSelector((state) => state.permission);
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  let userType = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  let userInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_KEY));
  let userName = userInfo && userInfo?.Name ? userInfo?.Name : "";
  // let Name = "";
  // console.log("nameeee", userInfo);
  const onClickLogout = () => {
    instance
      .post(`${API_PATH.LOGOUT}`)
      .then((res) => {
        if (res?.Success) {
          localStorage.clear();
          Auth.logout();
          Navigate(routeConstant.LOGIN);
          localStorage.setItem("Status", true);
        }
      })
      .catch((err) => {})
      .finally((f) => {});

    // UserService.logout();
    // setLogout(true);
    // Navigate(routeConstant.LOGIN);
  };

  const handleDrawerToggle = (event) => {
    setMobileOpen(!mobileOpen);
  };
  const onClickMenuItem = (item) => {
    const pathOrder = `${routeConstant.ORDER}`;
    const pathProcess = `${routeConstant.PROCESS}`;
    if (item === "dashboard") {
      Navigate(routeConstant.DASHBOARD);
    } else if (item === "process") {
      Navigate(pathProcess);
    } else if (item === "orders") {
      Navigate(pathOrder);
    } else if (item === "financial") {
      Navigate(`${routeConstant.FINANCE}/invoice`);
    } else if (item === "report") {
      Navigate(routeConstant.REPORT);
    } else if (item == "my team") {
      Navigate(routeConstant.TEAM);
    }
  };

  const drawer = (
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }} className="Cross-img">
        <CloseIcon onClick={handleDrawerToggle} />
      </Typography>
      <Divider />
      <List>
        <ListItem
          disablePadding
          onClick={() => {
            handleDrawerToggle();
            onClickMenuItem("dashboard");
          }}
        >
          <ListItemButton sx={{ textAlign: "center" }}>
            <ListItemText primary={t("Dashboard")} />
          </ListItemButton>
        </ListItem>

        {navItems.map((item, index) => {
          if (permissions[item.key]) {
            return (
              <ListItem
                key={index}
                disablePadding
                onClick={() => {
                  handleDrawerToggle();
                  onClickMenuItem(item.name);
                }}
              >
                <ListItemButton sx={{ textAlign: "center" }}>
                  <ListItemText primary={t(item.value)} />
                </ListItemButton>
              </ListItem>
            );
          }
        })}
      </List>
      <div className="header-button">
        <button
          className={i18n.language === "en" ? "active-lang" : ""}
          onClick={changeLanguage}
          value="en"
        >
          EN
        </button>
        <button
          className={i18n.language === "pt" ? "active-lang" : ""}
          onClick={changeLanguage}
          value="pt"
        >
          PT
        </button>
        <button
          className={i18n.language === "es" ? "active-lang" : ""}
          onClick={changeLanguage}
          value="es"
        >
          ES
        </button>
      </div>
      {/* <div className="bell-icon" style={{ paddingTop: "2rem" }}>
        <img
          src={`${basename}/icon/icon-bell.svg`}
          onClick={() => {
            Navigate(routeConstant.NOTIFICATION);
            handleDrawerToggle();
          }}
        />
      </div> */}
      <div
        className="d-flex justify-content-center mt-3"
        onClick={() => handleClickOpen()}
      >
        <div>
          <Button className="icon-btn">
            <img src={urlResolver("icon/company_icon.png")} />
          </Button>
        </div>
        <img
          style={{ cursor: "pointer" }}
          className="img-arrow-user"
          src={urlResolver("icon/icon-arrow-user.svg")}
        />
      </div>

      <div
        className="user-notification"
        style={{ flexDirection: "column", paddingTop: "2rem" }}
      >
        <p
          className="user-name"
          style={{ paddingBottom: "2rem", fontSize: "1.45rem" }}
        >
          {/* Hello, {userType.Name} */}
          Hello, {userName}
        </p>
        <button>
          <img
            style={{ marginRight: "1rem" }}
            // src={`${basename}/icon/icon-user.svg`}
            src={urlResolver(`icon/icon-user.svg`)}
          />
          {/* {logout ? (
            <ArrowDropUpIcon
              style={{ color: "#fff", fontSize: "3.5rem" }}
              onClick={(e) => {
                setLogout(false);
              }}
            />
          ) : (
            <ArrowDropDownIcon
              style={{ color: "#fff", fontSize: "3.5rem" }}
              onClick={(e) => {
                setLogout(true);
              }}
            />
          )} */}
          <img
            className={
              !logout
                ? "img-arrow-user "
                : "img-arrow-user  active-img-arrow-user"
            }
            onClick={(e) => {
              setLogout(!logout);
            }}
            src={urlResolver("icon/icon-arrow-user.svg")}
          />
        </button>

        {!logout ? (
          <div className="logoutButton-small">
            <div>
              <p onClick={() => onClickLogout()}>Log out</p>
            </div>
          </div>
        ) : null}
      </div>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const toggleTempOrgCode = (code) => {
    setTempSelectedOrgCodes((prev) => {
      const prevArr = Array.isArray(prev) ? prev : [];
      return prevArr.includes(code)
        ? prevArr.filter((c) => c !== code)
        : [...prevArr, code];
    });
  };

  return (
    <div className=" drawer-nav ">
      <Box sx={{ display: "flex" }}>
        <AppBar
          style={{ backgroundColor: "var(--color-blue2)" }}
          component="nav"
        >
          <div className="container-fluid">
            <Toolbar
              sx={{
                padding: "0 !important",
                // maxWidth: "1640px",
                width: "calc(100% - 40px)",
                margin: "0 auto",
                height: "87px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div className="main-div-small">
                <IconButton
                  color="inherit"
                  className="mui-button-small"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                  sx={{ mr: 2, display: { lg: "none" } }}
                >
                  <MenuIcon />
                </IconButton>
                <img
                  src={urlResolver("icon/logo-asia-tracking-white.svg")}
                  alt="logo"
                  className="small-screen-logo"
                />
              </div>

              <Typography
                className="mui-typography"
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, display: { xs: "none", lg: "block" } }}
              >
                <img
                  src={urlResolver("icon/logo-asia-tracking-white.svg")}
                  alt="logo"
                />
              </Typography>
              <Box
                sx={{ display: { xs: "none", lg: "block" } }}
                className="mui-box-div"
              >
                <div className="header-page">
                  <div className="header-page-div">
                    <div className="header-page-first-child">
                      <button
                        className="header-btn "
                        style={
                          location.pathname === routeConstant.DASHBOARD
                            ? { color: "white" }
                            : { color: "#ffffff6b" }
                        }
                        onClick={() => {
                          onClickMenuItem("dashboard");
                        }}
                      >
                        {t("Dashboard")}
                      </button>
                      <button
                        className="header-btn "
                        // key={index}
                        style={
                          location.pathname.includes(
                            "process".replace(/\s+/g, ""),
                          )
                            ? { color: "white" }
                            : { color: "#ffffff6b" }
                        }
                        onClick={() => {
                          onClickMenuItem("process");
                        }}
                      >
                        {t("Process")}
                      </button>
                      <button
                        className="header-btn "
                        // key={index}
                        style={
                          location.pathname.includes(
                            "orders".replace(/\s+/g, ""),
                          )
                            ? { color: "white" }
                            : { color: "#ffffff6b" }
                        }
                        onClick={() => {
                          onClickMenuItem("orders");
                        }}
                      >
                        {t("Orders")}
                      </button>
                      <button
                        className="header-btn "
                        // key={index}
                        style={
                          location.pathname.includes(
                            "financial".replace(/\s+/g, ""),
                          )
                            ? { color: "white" }
                            : { color: "#ffffff6b" }
                        }
                        onClick={() => {
                          onClickMenuItem("financial");
                        }}
                      >
                        {t("Financial")}
                      </button>
                      <button
                        className="header-btn "
                        // key={index}
                        style={
                          location.pathname.includes(
                            "report".replace(/\s+/g, ""),
                          )
                            ? { color: "white" }
                            : { color: "#ffffff6b" }
                        }
                        onClick={() => {
                          onClickMenuItem("report");
                        }}
                      >
                        {t("Report")}
                      </button>
                      {userType?.Roles === "Admin" ? (
                        <button
                          className="header-btn "
                          // key={index}
                          style={
                            location.pathname.includes(
                              "my team".replace(/\s+/g, ""),
                            )
                              ? { color: "white" }
                              : { color: "#ffffff6b" }
                          }
                          onClick={() => {
                            onClickMenuItem("my team");
                          }}
                        >
                          {t("My team")}
                        </button>
                      ) : null}

                      {/* {navItems.map((item, index) => {
                        if (permissions[item.key]) {
                          return (
                            <button
                              className="header-btn "
                              key={index}
                              style={
                                location.pathname.includes(
                                  item.value.replace(/\s+/g, "")
                                )
                                  ? { color: "white" }
                                  : { color: "#ffffff6b" }
                              }
                              onClick={() => {
                                onClickMenuItem(item.value);
                              }}
                            >
                              {item.value}
                            </button>
                          );
                        }
                      })} */}
                    </div>
                  </div>
                  <div className="user-main">
                    <div className="user-notification">
                      <p className="user-name">
                        {t("Hello")}, {userName}
                      </p>
                      <button
                        onClick={(e) => {
                          setLogout(!logout);
                        }}
                      >
                        <img
                          style={{ marginRight: "1rem" }}
                          src={urlResolver("icon/icon-user.svg")}
                        />

                        <img
                          className={
                            logout === true
                              ? "img-arrow-user "
                              : "img-arrow-user  active-img-arrow-user"
                          }
                          src={urlResolver("icon/icon-arrow-user.svg")}
                        />
                      </button>

                      {!logout ? (
                        <div className="logoutButton">
                          <p onClick={() => onClickLogout()}>Log out</p>
                        </div>
                      ) : null}
                    </div>
                    <div
                      className="d-flex me-3"
                      onClick={() => handleClickOpen()}
                    >
                      <div>
                        <Button className="icon-btn">
                          <img src={urlResolver("icon/company_icon.png")} />
                        </Button>
                      </div>

                      <img
                        style={{ cursor: "pointer" }}
                        className="img-arrow-user"
                        src={urlResolver("icon/icon-arrow-user.svg")}
                      />
                    </div>

                    {/* <div className="bell-icon">
                      <img
                        alt="notificationicon"
                        style={
                          location.pathname.includes("notification")
                            ? {
                                opacity: "1",
                              }
                            : {
                                opacity: "0.7",
                              }
                        }
                        src={`${basename}/icon/icon-bell.svg`}
                        onClick={() => {
                          Navigate(routeConstant.NOTIFICATION);
                        }}
                      />
                    </div> */}
                    <div className="header-button">
                      <button
                        className={i18n.language === "en" ? "active-lang" : ""}
                        onClick={changeLanguage}
                        value="en"
                      >
                        EN
                      </button>
                      <button
                        className={i18n.language === "pt" ? "active-lang" : ""}
                        onClick={changeLanguage}
                        value="pt"
                      >
                        PT
                      </button>
                      <button
                        className={i18n.language === "es" ? "active-lang" : ""}
                        onClick={changeLanguage}
                        value="es"
                      >
                        ES
                      </button>
                    </div>
                  </div>
                </div>
              </Box>
            </Toolbar>
          </div>
        </AppBar>
        <Dialog
          onClose={handleClose}
          open={open}
          className="company-code-dialog"
        >
          <List
            sx={{ pt: 0, maxHeight: 300, overflowY: "auto" }}
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

              const reachedBottom =
                scrollHeight - scrollTop <= clientHeight + 20;

              const hasMoreData = companyDetails.length < totalItems;

              if (reachedBottom && hasMoreData && !loading) {
                const nextPage = page + 1;
                setPage(nextPage);
                getCompanyCode(nextPage);
              }
            }}
          >
            {/* Show message when no data */}
            {!loading && companyDetails.length === 0 && (
              <ListItem className="d-flex justify-content-center">
                <ListItemText
                  primary="No organization found"
                  primaryTypographyProps={{
                    style: {
                      fontSize: "16px",
                      color: "#797979",
                      textAlign: "center",
                      width: "100%",
                      height: "30vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    },
                  }}
                />
              </ListItem>
            )}
            {companyDetails.map((company) => (
              <ListItem disablePadding key={company.id}>
                <ListItemButton
                  selected={tempSelectedOrgCodes.includes(company.code)}
                  onClick={() => toggleTempOrgCode(company.code)}
                >
                  <Checkbox
                    value={company.code}
                    checked={tempSelectedOrgCodes.includes(company.code)}
                    onChange={(e) => {
                      e.stopPropagation();
                      toggleTempOrgCode(company.code);
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <ListItemText className="ms-3">
                    <p
                      className="m-0 company-name"
                      style={{
                        fontFamily: "siena-medium !important",
                        fontSize: "18px !important",
                        color: "#4e4e4e !important",
                        lineHeight: "24px !important",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "200px",
                      }}
                      title={company.name}
                    >
                      {company.name}
                    </p>
                    <p
                      className="m-0 company-code"
                      style={{
                        fontFamily: "siena-light !important",
                        fontSize: "16px !important",
                        color: "#797979 !important",
                        lineHeight: "21px !important",
                      }}
                    >
                      {company.cnpj}
                    </p>
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ))}
            {loading && (
              <ListItem className="d-flex justify-content-center">
                <CircularProgress sx={{ color: "#797979" }} />
              </ListItem>
            )}
          </List>
          {!loading && companyDetails.length > 0 && (
            <DialogActions>
              <Button
                onClick={handleSave}
                variant="outlined"
                sx={{
                  borderRadius: "25px",
                  color: "var(--color-blue1)",
                  borderColor: "var(--color-blue1)",
                }}
              >
                Save
              </Button>
            </DialogActions>
          )}
        </Dialog>
        <Box component="nav">
          <div className="container-fluid drawer-sidebar">
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              hideBackdrop={true}
              ModalProps={{
                keepMounted: true,
              }}
              sx={{
                display: { xl: "block", lg: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                },
              }}
            >
              {drawer}
            </Drawer>
          </div>
        </Box>
      </Box>
    </div>
  );
}

export default withTranslation()(Header);
